import { localSettingObservable } from "../utils/localSettingObservable";

export class FtueStore {
    @localSettingObservable("ftue.operate.joystick")
    public joystick: boolean = true;
}
